var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-camera-view"}},[_c('div',{attrs:{"id":"page-camera-view"}},[_c('iframe',{staticClass:"center",attrs:{"width":"100%","height":"490","src":_vm.reset,"allowfullscreen":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }